<div class="floating-button">
    <app-icon iconName="plus" class="text-white floating-button__icon"></app-icon>
</div>
